module.exports = __webpack_public_path__ + "img/archesthumb.9cb5c1f4.gif";